import {DRIVERS_NEW_ERROR, GET_DRIVERS_NEW} from 'app/types'
import * as ActionTypes from "../types";

const initialState = {
    driversnew:[],
    loading:true
}

export default function driversNewReducer (state = initialState, action) {

    switch(action.type){
        case GET_DRIVERS_NEW:
            return {
                ...state, 
                driversnew : action.payload , 
                loading : false 
            }
        case DRIVERS_NEW_ERROR : 
            return {
                ...state,
                loading: false , 
                error : action.payload
            }
        case ActionTypes.APPROVE_DRIVER:
            const driversNotApproved = state.driversnew.filter( driverSub => driverSub._id !==action.payload);
            return {
                ...state ,
                driversnew: driversNotApproved,
                loading : false ,
                error : null
            }

        default: return state
    }
    
}

 